import React from "react";
import {
  Box,
  Typography,
  Link,
  Stack,
  Tooltip,
  IconButton
} from "@mui/material";

import Facebook from "@mui/icons-material/Facebook";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        py: 4,
        textAlign: "center",
        background: "linear-gradient(to right, #1e1e2f, #27293d)",
        color: "#ffffffcc",
        borderTop: "1px solid #3a3a5a",
        fontSize: "0.9rem",
        fontWeight: 300,
        letterSpacing: "0.5px"
      }}
    >
      {/* <Box sx={{ display: "flex", justifyContent: "center", gap: 4, mt: 2 }}>
        <Link href="#" underline="hover" sx={{ color: "#aaa" }}>
          หน้าแรก
        </Link>
        <Link href="#" underline="hover" sx={{ color: "#aaa" }}>
          ติดต่อ
        </Link>
      </Box> */}

      {/* <Typography variant="body2" sx={{ mt: 2, color: "#888" }}>
        โทร: 0-5394-2508 ต่อ 304
      </Typography> */}

      {/* <Stack direction="row" spacing={2} justifyContent="center" mt={3}>
        <Tooltip title="Facebook">
          <IconButton href="#" target="_blank">
            <Facebook sx={{ color: "#ffffffcc" }} />
          </IconButton>
        </Tooltip>
       
      </Stack> */}

      <Typography variant="body2">
        &copy; {new Date().getFullYear()} RIHES Substance Abuse Unit. All rights
        reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
